import {axiosUtil} from "../../../../utils/axios_util";

const MyApplicationApi = {
    //用户申请分页查询
    applyPage(data:powerSearchData) {
        return axiosUtil({
            url: '/xpool/application/page',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },

    //获取审批详情
    getApprovalDetail(data:any) {
        return axiosUtil({
            url: `/xpool/apply/get_approval_detail/${data}`,
            method: 'get',
            data,
        })
    },

    //分页查询批量导入处理的X池号码
    getApplyDetail(data:powerSearchData) {
        return axiosUtil({
            url: `/xpool/apply/get_import_number/page/${data.applyNo}`,
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },

    //获取X池号码报备书的临时下载地址
    getPreSignedUrl(data:any) {
        return axiosUtil({
            url: `/xpool/application/get_file_download_url?objectName=${data}`,
            method: 'get',
        })
    },

    //获取捞号申请详情
    getApplicationDetail(applicationNo:string) {
        return axiosUtil({
            url: `/xpool/application/get_application_detail/${applicationNo}`,
            method: 'get',
        })
    },
    //获取自带号码申请详情
    getApplicationSelfDetail(data:any) {
        return axiosUtil({
            url: `/xpool/application/get_application_detail/customer/${data.no}`,
            method: 'get',
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
    //批量新增X池号码预览
    addPreview(xpoolNo:string,data:any) {
        return axiosUtil({
            url: `/xpool/application/batch/add/preview/${xpoolNo}`,
            method: 'post',
            data,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    },
    //预览数据分页查询
    previewPage(data:any) {
        return axiosUtil({
            url: `/xpool/application/batch/preview/page/${data.xpoolNo}`,
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
    //错误数据导出
    exportError(data:any) {
        return axiosUtil({
            url: `/xpool/application/export/error`,
            method: 'post',
            // headers: { 'Content-Type': 'application/json' },
            responseType: 'blob',
            data
        })
    },
    //号码文件导出
    exportApplicationNumber(data:any) {
        return axiosUtil({
            url: `/xpool/application/export/application/number/detail`,
            method: 'post',
            responseType: 'blob',
            params: data
        })
    },
    //X池号码导入申请预览 (号库筛选号码)
    xNumberApplyPreview(data:any) {
        return axiosUtil({
            url: `/xpool/application/preview/xpool_number_import`,
            method: 'post',
            headers: { 'Content-Type': 'multipart/form-data' },
            data
        })
    },
    //X池号码导入申请 (号库筛选号码)
    xNumberApply(data:any) {
        return axiosUtil({
            url: `/xpool/application/xpool_number_import`,
            method: 'post',
            data
        })
    },
    //预览数据错误类型统计
    previewCount(data: string) {
        return axiosUtil({
            url: `/xpool/application/batch/preview/count/${data}`,
            method: 'post',
            data
        })
    },
    //X池号码导入申请 (客户自带号码)
    xNumberAdd(data:any) {
        return axiosUtil({
            url: `/xpool/application/xpool_number_import_customized/${data.xpoolNo}`,
            method: 'post',
            data
        })
    },
    //获取临时上传地址
    preSignedPut(data:any) {
        return axiosUtil({
            url: `/xpool/application/pre-signed-put`,
            method: 'post',
            data
        })
    },
    //根据字典类型获取字典数据
    getByType(data:any) {
        return axiosUtil({
            url: `/dictionary_manager/getByType`,
            method: 'get',
            params:data
        })
    },
    //获取省市字典
    getProvinceCityCodes() {
        return axiosUtil({
            url: `/dictionary_manager/getProvinceCityCodes`,
            method: 'get'
        })
    },
}

export default MyApplicationApi
